import { GroupType } from "@/types/analysis/ProjectAnalysis";
import i18n from "@i18n/i18n";
import AccountTreeIcon from "@mui/icons-material/AccountTree";
import SchemaIcon from "@mui/icons-material/Schema";
import { ToggleButton, ToggleButtonGroup, Tooltip } from "@mui/material";

interface GroupTypeToggleProps {
  value: GroupType;
  onChange: (event: any, newValue: GroupType) => void;
}

const GroupTypeToggle = (props: GroupTypeToggleProps) => {
  return (
    <ToggleButtonGroup value={props.value} exclusive onChange={props.onChange} size="small">
      <Tooltip title={i18n.t("results-tab.title.group-type-scenario")}>
        <span>
          <ToggleButton value={GroupType.Scenario}>
            <SchemaIcon />
          </ToggleButton>
        </span>
      </Tooltip>
      <Tooltip title={i18n.t("results-tab.title.group-type-model")}>
        <span>
          <ToggleButton value={GroupType.Model}>
            <AccountTreeIcon />
          </ToggleButton>
        </span>
      </Tooltip>
    </ToggleButtonGroup>
  );
};

export default GroupTypeToggle;
